import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { WaterMeterService } from 'app/shared/services/water-meter.service';
import { FileUploadComponent } from '../../../file-upload/file-upload.component';
import { FileUploadService } from 'app/shared/services/file-upload.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'app/shared/services/dialog.service';
import { AuthService } from 'app/shared/services/auth.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import { NbThemeService } from '@nebular/theme';
import { BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import * as moment from 'moment';

@Component({
  selector: 'ngx-water-meter',
  templateUrl: './water-meter.component.html',
  styleUrls: ['./water-meter.component.scss']
})
export class WaterMeterComponent implements OnInit {

  datepickerConfig : Partial<BsDatepickerConfig>
  defaultDate : Date = new Date();

  dataList =[];

  isDark: boolean = false;
  isShowAttachBtn: boolean=false;
  form: FormGroup;
  isSaveBtnDisabled : boolean= false;
  isValidFormData: boolean = true;
  showProcessingIndicator =false;

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };


   meterType =[
    {value: 'Black Meter'},
    {value: 'Red Meter'},
    {value: 'Garden water'},

  ];
  
  
  validationMessages = {
    'refCode' : { 'required': 'This field is required' },
    'meterType' : { 'required': 'This field is required' },
    'fromDate' : { 'required': 'This field is required' },
    'fromTime' : { 'required': 'This field is required' },
    'firstReading' : { 'required': 'This field is required' },
    'toDate' : { 'required': 'This field is required' },
    'toTime' : { 'required': 'This field is required' },
    'secondReading' : { 'required': 'This field is required' },
    'consume' : { 'required': 'This field is required' },
  
  };

  formErrors = {
    'refCode' : "",
    'meterType' : "",
    'fromDate' : "",
    'fromTime' : "",
    'firstReading' : "",
    'toDate' : "",
    'toTime' : "",
    'secondReading' : "",
    'consume' : "",

  };




    constructor(private fb: FormBuilder,
                private waterMeterService: WaterMeterService,
                private fileUploadService:FileUploadService,
                private authService: AuthService,
                private toastr: ToastrService,
                private router : Router, 
                private themeService: NbThemeService,
                private dialogService: DialogService
              ) {
                this.datepickerConfig = Object.assign({},
                  {   
                    showWeekNumbers:false,
                    dateInputFormat : 'YYYY-MM-DD'
                  });
              }
              
               

              

  ngOnInit() {
      
    this.form = this.fb.group({
      id : [null],
      refCode: ['',Validators.required],
      meterType: ['',Validators.required],
      fromDate: ['',Validators.required],
      fromTime: ['',Validators.required],
      firstReading: ['',Validators.required],
      toDate: ['',Validators.required],
      toTime: ['',Validators.required],
      secondReading: ['',Validators.required],
      consume: ['',Validators.required],

    });

  
   this.form.valueChanges.subscribe((data) => {
    this.logValidationErrors(this.form);
  });


    this.getDataTableRowData();
   this.getControlPermissions();
    this.themeService.onThemeChange()
    .subscribe(themeName =>{
         this.isDark  = themeName.name ==='dark' ? true : false;
       });

  } /////// end onInit

  
  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='WM'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }


  getAll(value){
    this.waterMeterService.getPreviuosData(value)
     .subscribe(
        (data) => {
                  this.dataList = data;
                  this.getPreviousData(this.dataList);
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });  
       
     }

  attachFileButtonClick(){
    this.fileUploadService.refNo = this.form.value.guestId;
     const dialogConfig = new MatDialogConfig();
     dialogConfig.disableClose = true;
     dialogConfig.autoFocus = true;
     dialogConfig.width = "75%";
     this.dialogService.openDialog(FileUploadComponent,dialogConfig);
        
    }

  newButtonClick(): void {
    this.isShowAttachBtn=false; 
    this.isSaveBtnDisabled = false;
    this.form.reset();
    this.enableForm();
    this.getMaxId();
    
   }

   
  
   getMaxId(){
    var customerId = 0;
    var sCustomerId : String;
  
    this.waterMeterService.getMaxId()
    .subscribe(
      (res) => {
                  customerId = Number(res[0].MaxId) + 1;
                  sCustomerId = customerId.toString().padStart(5,'0');
                  this.form.patchValue({
                    refCode : "WMR" + sCustomerId
                  });
                  

                },        
      (err) =>  {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                }, 
      )



   }


   getPreviousData(filteredList){
    this.form.patchValue({
      fromDate : moment(filteredList[0].ToDate).format("YYYY-MM-DD"),
      fromTime : filteredList[0].ToTime,
      firstReading : filteredList[0].SecondReading,

    });

   }

  isNumeric(value){
    if(!isNaN(value) &&  !isNaN(parseFloat(value))){
      return true;
    } 
     return false;
  
  }



   calculateAmounts(){
    let consumeDiff =null;

    if(this.form.value.firstReading && 
      this.isNumeric(this.form.value.firstReading) && 
      this.form.value.secondReading && 
      this.isNumeric(this.form.value.secondReading)){

        consumeDiff = this.form.value.secondReading - this.form.value.firstReading;

    }

    
  
    this.form.patchValue({
      consume :  consumeDiff,
    });

   }

  saveButtonClick(): void {
    var data : any;
    
    this.logValidationErrors(this.form,true);
    const formData = this.mapFormValuesToCustomerModel();  

          if(this.isFilledFromFields()){
            
              if(!this.form.value.id){
                this.showProcessingIndicator = true;
                this.waterMeterService.create(formData)
                .subscribe(
                  (res) => {

                              if(res.success === 0){
                                this.form.patchValue({
                                refCode : res.autoId
                                });
                              this.saveButtonClick();
                              this.showProcessingIndicator = false; 
                              
                              }else if(res.success === 1){
                                data=res;
                                this.toastr.success('Record added successfully','Success'); 
                                this.showProcessingIndicator = false; 
                                this.isShowAttachBtn = true;
                                this.newButtonClick()
                             }   

                            },        
                  (err) =>  {
                              this.toastr.error('Failed to add record','Failure');                            
                              this.showProcessingIndicator = false;
                              if(err instanceof HttpErrorResponse){                 
                                if(err.status == 401){
                                  this.router.navigate(['/login']);
                                }
                              }
                              console.log(err);
                            }, 
                  )
  
                   

            }else{
            this.dialogService.openConfirmDialog('Are you sure you want to update this record?')
            .afterClosed().subscribe(res =>{
              if(res){
              this.showProcessingIndicator = true;
              this.waterMeterService.update(formData)
            .subscribe(
              (res) => {
                          this.toastr.success('Record updated successfully','Success');    
                          this.showProcessingIndicator = false;  
                          this.newButtonClick();
                        },        
              (err) =>  {
                          this.toastr.error('Failed to update record','Failure');
                          this.showProcessingIndicator = false;
                          if(err instanceof HttpErrorResponse){                 
                            if(err.status == 401){
                              this.router.navigate(['/login']);
                            }
                          }
                          console.log(err);
                        }, 
                      )

          }else{
            this.showProcessingIndicator = false;
          }
            })

        }

      }
      else{
        this.toastr.warning('Required Fields cannot be empty or invalid.','Error Message');
        this.showProcessingIndicator = false;
        
      } 
                       
         
   }

  

   enableForm():void{
    Object.keys(this.form.controls).forEach(key => {
      this.form.controls[key].enable();
      //console.log(key)
    });
  }


  disableForm():void{
    Object.keys(this.form.controls).forEach(key => {
      this.form.controls[key].disable();   
    });
  }


  
  logValidationErrors(group: FormGroup = this.form,isDirty :boolean=false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if(isDirty)
      {
        this.enableForm();
        this.form.controls[key].markAsTouched();
      }
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } 
    });
  }


  isFilledFromFields() : boolean {
    for (var key in this.formErrors) {
      if (this.formErrors[key] !== null && this.formErrors[key] != "" && this.formErrors[key] != '')
          return false;
        }
        return true;
}

  mapFormValuesToCustomerModel(){
    let formData ={
      ...this.form.value,
      fromDate : moment(this.form.value.fromDate).format("YYYY-MM-DD"),
      toDate : moment(this.form.value.toDate).format("YYYY-MM-DD"),
      createdBy : this.authService.getUserLoggedIn(),
    }

    return formData;
    
  }
   



viewData(data){

  this.form.patchValue({
    id : data.Id,
    refCode:data.RefCode,
    meterType:data.MeterType,
    fromDate:data.FromDate ?  moment(data.FromDate).format("YYYY-MM-DD"): null,
    fromTime:data.FromTime,
    firstReading:data.FirstReading,
    toDate:data.ToDate ?  moment(data.ToDate).format("YYYY-MM-DD"): null,
    toTime:data.ToTime,
    secondReading:data.SecondReading,
    consume:data.Consume,
    createdBy:data.CreatedBy,


   
  })

  this.isShowAttachBtn = true; 
}

getDataTableRowData(){
  var data  = this.waterMeterService.dataRow;
  if(data){
    this.viewData(data);
  }
  else{
    this.newButtonClick()
  }
  
                       
}

}//end class

